export default __webpack_public_path__ + "static/media/17.67b7f72c.png";